const TicketShowPassword = {
  mounted(){
    let input = this.el.querySelector('input')
    let button = this.el.querySelector('button')
    input.addEventListener("keypress", event => {
      if(event.key === 'Enter'){
        this.pushEvent("unlock_ticket_show", {password: input.value})
        input.value = ""
      }
    })
    button.addEventListener('click', event => {
      this.pushEvent("unlock_ticket_show", {password: input.value})
      input.value = ""
    })
  }
}

export default { TicketShowPassword };
